var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.397,
    height: 19.397,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16678",
    d: "M9.7 0a9.654 9.654 0 1 0 6.871 2.828A9.7 9.7 0 0 0 9.7 0Zm.882 14.107a.882.882 0 0 1-1.763 0v-5.29a.882.882 0 1 1 1.763 0ZM9.7 6.172a.882.882 0 1 1 .882-.882.882.882 0 0 1-.882.882Z",
    fill: "#678bff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.348b7a20c528768a8c9f2d7a30e0514f.svg";
export { ForwardRef as ReactComponent };